import { Injectable } from '@angular/core';
import { ApiHttpService } from './api-http.service';
import { Observable } from 'rxjs';

@Injectable()
export class TacticalLiaisonService {

  constructor(private apiHttp: ApiHttpService) { }

  public get = (): Observable<TacticalLiaison[]> => {
    return this.apiHttp.get<TacticalLiaison[]>('users/tacticalliaisons');
  }
}

export interface TacticalLiaison {
    id: number;
    email: string;
    givenName: string;
    isActive: boolean;
    surname: string;
    username: string;
    userPrincipalName: string;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/tactical-liaison.service.ts